import { snakeCase } from 'lodash';

import { makeActionKey } from './CrudActionContainer';
import { getActionHookBuilder } from './action-hook-builder';

const entityName = klass =>
  snakeCase(klass.name)
    .toUpperCase()
    .replace(/_ACTIONS$/, '');

class SignUpActions {
  entity: string;
  setEmailAction: string;
  resetAction: string;

  constructor() {
    this.entity = entityName(this.constructor);
    this.setEmailAction = makeActionKey(this.entity, 'SET_EMAIL');
  }

  setEmail(payload: string | null) {
    return {
      type: this.setEmailAction,
      payload,
    };
  }

  reset() {
    return { type: this.resetAction };
  }
}

export const signUpFormActions = new SignUpActions();
export default signUpFormActions;

export const useSignUpFormActions = getActionHookBuilder(signUpFormActions, [
  'setEmail',
]);
